// redirect.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {


  constructor(private router: Router) { }

  canActivate(): boolean {
    const token = localStorage.getItem('authToken');

    if (token) {
      this.router.navigate(['smartdocs/filer-summary']);
    } else {
      //this.router.navigate(['/login']);
      this.router.navigate(['/login']);
    }

    return false; // stop activation of 'redirector' route
  }
}
